/**
 * Object prototype
 */
(function () {

    function extendIfUndefined(destination, source) {
        for (var property in source) {
            if (destination[property] == undefined) {
                destination[property] = source[property];
            }
        }
        return destination;
    }

    function extend(destination, source) {
        for (var property in source) {
            destination[property] = source[property];
        }
        return destination;
    }


    function merge(into, from) {
        for (var prop in from) {
            if (isObject(from[prop])) {
                if (!isObject(into[prop])) {
                    into[prop] = {};
                }
                into[prop] = merge(into[prop], from[prop]);
            }
            else
                into[prop] = from[prop];
        }
        return into;
    };

    function each(iteratable, fn, context) {
        for (var i in iteratable) {
            if (iteratable.hasOwnProperty(i)) {
                fn.call(context, iteratable[i], i, iteratable);
            }
        }
    };

    function deepClone(obj) {
        return JSON.parse(JSON.stringify(obj));
    };

    function isFunction(object) {
        if (object === undefined || object === null) {
            return false;
        }
        return Object.prototype.toString.call(object) === '[object Function]';
    }

    function isArray(object) {
        return Object.prototype.toString.call(object) === '[object Array]';
    }

    function isObject(object) {
        return Object.prototype.toString.call(object) === '[object Object]';
    }
    function isPrimitive(object) {
        var primitiveTypes = {'undefined': 1, 'boolean': 1, 'number': 1, 'string': 1};
        return (object === null) || (typeof (object) in primitiveTypes);
    }

    function part(obj, keys) {
        var result = {};

        keys.each(function (key) {
            if (obj[key] != undefined) {
                result[key] = obj[key];
            }
        });

        return result;
    }

    function enshureIsArray(object) {
        if (!isArray(object)) {
            return [object];
        }
        return object;
    }

    function mix(child, parent) {
        if (isArray(parent)) {
            parent.each(function (p) {
                (p.bind(child))();
            });
        } else {
            (parent.bind(child))();
        }
    }

    function compare(obj1, obj2) {
        for (var i in obj1) {

            if (obj2[i] === undefined) {
                return false;
            }

            if (typeof obj2[i] == "object" && typeof obj1[i] == "object") {
                if (!Object.compare(obj2[i], obj1[i])) {
                    return false;
                }
                continue;
            }

            if (obj2[i] === undefined || obj2[i] != obj1[i]) {
                return false;
            }
        }
        return true;
    };

    function compare_debug(obj1, obj2) {
        for (var i in obj1) {

            if (obj2[i] === undefined) {
                console.log(i, ' obj2[i] is undefined');
                return false;
            }

            if (Object.isArray(obj2[i]) && Object.isArray(obj1[i])) {
                console.log(i, "is array > compare arrays", obj2[i], obj1[i]);

                if (!obj2[i].equal(obj1[i])) {
                    console.log(obj1[i], "not equal", obj2[i]);
                    return false;
                }
                continue;
            } else {
                if (typeof obj2[i] == "object" && typeof obj1[i] == "object") {
                    console.log(i, "is object > compare");
                    if (!Object.compare_debug(obj2[i], obj1[i])) {
                        return false;
                    }
                    continue;
                }
            }

            if (obj2[i] != obj1[i]) {
                console.log(i, ' key, 2:', "«" + obj2[i] + "»", " 1: ", "«" + obj1[i] + "»");
                return false;
            }
        }
        return true;
    };

    extend(Object, {
        compare: compare,
        compare_debug: compare_debug,
        enshureIsArray: enshureIsArray,
        extend: extend,
        merge: merge,
        extendIfUndefined: extendIfUndefined,
        deepClone: deepClone,
        part: part,
        each: each,
        isFunction: isFunction,
        isArray: isArray,
        isObject: isObject,
        isPrimitive: isPrimitive,
        mix: mix,
        inherit: function () {}
    });
})();

if (Object.values === undefined) {
    Object.values = function(obj) {
        var res = [];
        for (var i in obj) {
            if (obj.hasOwnProperty(i)) {
                res.push(obj[i]);
            }
        }
        return res;
    }
}


var _each = Object.each();


/**
 * Boolean prototype
 */
String.prototype.toInt = function() {
    var c;
    return isNaN(c = parseInt(this))? 0 : c;
};

/**
 * Array prototype
 */
(function() {
	var arrayProto = Array.prototype,
		_each = arrayProto.forEach || (function each(fn, context) {
			for (var i = 0, len = this.length; i < len; ++i) {
				if (i in this) {
					fn.call(context, this[i], i, this);
				}
			}
		});
	Array.prototype.each = _each;
	
	function _indexOf(searchElement , fromIndex) {
	    var i, pivot = (fromIndex) ? fromIndex : 0;
	
	    if (!this) {throw new TypeError();}
	
	    var length = this.length;
	    if (length === 0 || pivot >= length) {
	      return -1;
	    }
	
	    if (pivot < 0) {
	    pivot = length - Math.abs(pivot);
	    }
	
	    for (i = pivot; i < length; i++) {
	      if (this[i] === searchElement) {
	        return i;
	      }
	    }
		return -1;
	};
	
	
	Object.extend(arrayProto, {
		each:	_each,
		_each:  _each
	});
	
	if (!arrayProto.indexOf) arrayProto.indexOf = _indexOf;
})();

Object.extend(Array.prototype,{
	range: function(first, last, step) {
		this.length = 0;
		
		switch (arguments.length) {
			case 0:
				return this;
				break;
			case 1:
				last = first;
				first = 0;
				step = 1;
				break;
			case 2:
				step = 1;
				break;
		}
		for (var i = first; i< last; i+=step) {
			this.push(i);
		}
		return this;
	},

    pushAll: function (vals) {
        vals.each(function (val) {
            this.push(val);
        }.bind(this));
        return this;
    },


    fori: function (start, stop, callback) {
        return [].range(start, stop + 1).each(callback);
    },

    detect: function (iterator) {
        var founded = undefined,
            context = arguments[1] || this;

        this.some(function (element) {
            if (iterator.apply(context, [element])) {
                founded = element;
                return true;
            }
            return false;
        });

        return founded;
    },
	
	search: function(needle) {
		var start = arguments[1]||0;
		for (var i=start; i < this.length; i++) {
			if (this[i] == needle) {
				return i;
			}
		}
		return -1;
	},
	
	compact: function() {
		for (var i=0;i<this.length;i++) {
			if (!this[i]) { 
				this.splice(i, 1);
				i--;
			}
		}
		return this;
	},
	
	remove:  function(value) {
		var io = -1;
		while(  (io = this.indexOf(value)) >=0   )  {
		     this.splice(io,1);
		};
	    return this;
	},
	
	unique: function() {
		var unique = [];
		this.each(function(value){
			if (unique.search(value) == -1) {
	            unique.push(value);
	        }
		},this);
		return unique;
	},
        
        /**
         * 
         * @param {Array} other - array to compare
         * @returns {Boolean}
         */
        equal: function(other) {
            if (this.length != other.length) {
                return false;
            }
            return other.slice(0).exclude(this).length == 0;
        },
	
	include: function(values) {
		 for (var i = 0; i < values.length; i++) {
			 if (this.indexOf(values[i]) == -1) {
				 this.push(values[i]);
			 }
		 }
		 return this;
	},
	
	has: function(value) {
		return this.indexOf(value)>-1;
	},

    contains: function (value) {
        return this.some(function (i) {
            return i == value;
        });
    },
	
	exclude: function(values) {
		for (var i = 0; i < values.length; i++) {
			this.remove(values[i]);
		}
		return this;
	},

    groupBy: function(key) {
        var assoced = {},
            result = [],
            describeOutput = !!arguments[1];

        this.each(function(line){
            if (assoced[line[key]] === undefined) {
                assoced[line[key]] = [];
            }
            assoced[line[key]].push(line);
        });

        Object.each(assoced, function(value){
            if (describeOutput) {
                result.push({value: value[0][key], key: key,  children: value});
                return true;
            }
            result.push(value);
        });
        return result;
    },

    assoc: function (key) {

        var mapField = arguments[1] || null;

        var result = {};
        this.each(function (e) {
            result[e[key]] = mapField===null? e : e[mapField];
        });
        return result;
    },

    assoced: function(key) {
        var result = {};
        this.each(function (e) {
            if (result[e[key]]===undefined) {
                result[e[key]] = [];
            }
            result[e[key]].push(e);
        });
        return result;
    },
	
        
        intersect: function(a) {
	    return this.filter(function(i) {return (a.indexOf(i) > -1);});
        },
        
	diff: function(a) {
	    return this.filter(function(i) {return !(a.indexOf(i) > -1);});
	},
        
        last: function() {
            return this[this.length-1];
        },
        
        firstValue: function() {
            return this.detect(function(val){
                if (val == undefined || val === null) {
                    return false;
                }
                return val.length !== undefined || val*1 == val;
            });
        },

    /**
     * Сортирует массив
     *
     * [].sortArray("name")
     * [].sortArray(["type","name"]) - отсортирует сначала по типу, если тип совпадает - по имени
     * [].sortArray([{field: name, order: -1, natural: true}, {field: type, natural: true}])
     * [].sortArray(["type","name"], -1) - отсортирует все в обратном порядке, сначала по типу потом по имени
     *
     *
     * @param {(string|string[]|Object[])} fields - параметры сортировки
     * @param {number} [order=1] - дефолтное направление сортировки
     * @param {string} fields[].field - поле для сортировки
     * @param {number} fields[].order - направление сортировки
     * @param {boolean} fields[].natural - использовать NaturalSorter
     * @returns {Array.<*>}
     */
    sortArray: function(fields, order) {
        fields = Object.enshureIsArray(fields);

        var defaultOrd = arguments[1] ? arguments[1] : 1,
            u = window['ko']?  ko.unwrap : function(val) { return Object.isFunction(val)? val() : val;  };

        function getFieldSettings(fieldSettings) {
            if (fieldSettings.field === undefined) {
                fieldSettings = {
                    field: fieldSettings
                };
            }

            fieldSettings = Object.extend({
                order: defaultOrd,
                natural: false
            },fieldSettings);
            return fieldSettings;
        }

        fields = fields.map(function(settings){
            return getFieldSettings(settings);
        });

        return this.sort(function(a, b){
            var comparator = 0;

            fields.some(function(settings){

                //settings = getFieldSettings(settings);

                var aValue = u(a[settings.field]),
                    bValue = u(b[settings.field]);

                if (aValue === undefined) {
                    aValue = 0;
                }
                if (bValue === undefined) {
                    bValue = 0;
                }

                if (aValue === bValue) {
                    comparator = 0;
                    return false;
                }
                if (settings.natural) {
                    comparator = String.naturalSorter(aValue, bValue) * settings.order;
                    return true;
                }


                comparator = aValue > bValue ? settings.order : -settings.order;
                return true;
            });

            return comparator;
        });

    },

    toRange: function () {
            var separator = arguments[0]||"–";


        var stations = this.unique();

        var groups = {};

        var namedGroup = function (prefix) {

            var suffixed = arguments[1] || false;

            this.name = prefix;
            this.items = [];

            function sortItems() {
                if (!suffixed) {
                    return true;
                }
                this.items.sort(function (a, b) {
                    return a.suffix * 1 > b.suffix * 1 ? 1 : -1;
                });

            }

            this.getStations = function () {
                sortItems.apply(this);

                var collector = [],
                    lastValue = 0,
                    strings = [];

                if (!suffixed) {
                    return this.name;
                }

                var freeCollector = function () {

                    if (collector.length > 0) {
                        var interval = collector.length > 1 ? (collector[0] + separator + collector[collector.length - 1]) : collector[0];
                        strings.push(/*this.name + " " + */interval);
                    }
                    collector = [];
                };

                this.items.each(function (item) {
                    if (lastValue != 0 && lastValue != item.suffix - 1) {
                        freeCollector.apply(this);
                    }

                    lastValue = item.suffix;
                    collector.push(lastValue);
                }.bind(this));
                freeCollector.apply(this);
                return this.name + " " + strings.join(", ");
            };
        };

        var namedStations = function (name) {
            this.real = $.trim(name);

            var matches = name.match(/^(.+?)(\s+[\d]+)$/, this.real);

            this.prefix = matches ? $.trim(matches[1]) : this.real;
            this.suffix = (matches && matches.length > 1) ? $.trim(matches[2]) * 1 : null;
        };

        stations.sort(function (a, b) {
            return a < b ? -1 : 1;
        });


        stations.each(function (station) {
            var named = new namedStations(station);

            var key = named.prefix + (named.suffix == null ? "-unprefixed" : "");

            if (groups[key] == undefined) {
                groups[key] = new namedGroup(named.prefix, !(named.suffix == null));
            }

            groups[key].items.push(named);
        });


        var fullString = [];

        Object.each(groups, function (group) {
            fullString.push(group.getStations());
        });

        return fullString.length > 0 ? fullString.join("; ") : "";
    },


        naturalSort: function (caseInsensitive) {
            for (var z = 0, t; t = this[z]; z++) {
                this[z] = [];
                var x = 0, y = -1, n = 0, i, j;
                while (i = (j = t.charAt(x++)).charCodeAt(0)) {
                    var m = (i == 46 || (i >= 48 && i <= 57));
                    if (m !== n) {
                        this[z][++y] = "";
                        n = m;
                    }
                    this[z][y] += j;
                }
            }

            this.sort(function (a, b) {
                for (var x = 0, aa, bb; (aa = a[x]) && (bb = b[x]); x++) {
                    if (caseInsensitive) {
                        aa = aa.toLowerCase();
                        bb = bb.toLowerCase();
                    }
                    if (aa !== bb) {
                        var c = Number(aa), d = Number(bb);
                        if (c == aa && d == bb) {
                            return c - d;
                        } else
                            return (aa > bb) ? 1 : -1;
                    }
                }
                return a.length - b.length;
            });
            for (var z = 0; z < this.length; z++) {
                this[z] = this[z].join("");
            }
        }
});



Array.naturalSorter = function (as, bs) {
    var a, b, a1, b1, i = 0, n, L,
            rx = /(\.\d+)|(\d+(\.\d+)?)|([^\d.]+)|(\.\D+)|(\.$)/g;
    if (as === bs)
        return 0;
    
    as = as||"";
    bs = bs||"";
    
    if (as=="") {
        return -1;
    }
    
    if (bs=="") {
        return 1;
    }
    
    a = as.toLowerCase().match(rx);
    b = bs.toLowerCase().match(rx);
    L = a.length;
    while (i < L) {
        if (!b[i])
            return 1;
        a1 = a[i],
                b1 = b[i++];
        if (a1 !== b1) {
            n = a1 - b1;
            if (!isNaN(n))
                return n;
            return a1 > b1 ? 1 : -1;
        }
    }
    return b[i] ? -1 : 0;
};

String.naturalSorter = Array.naturalSorter;

/**
 * Strings prototypes
 */
String.prototype.pad = function(pad) {
	var s = this;
	while (s.length < pad) {
		s = '0' + s;
	}
	return s;
};

String.prototype.toQueryParams = function() {
	var match = this.match(/([^?#]*)(#.*)?$/);
	if (!match) return { };
	
	var spl = match[1].split('&'),
		params = {};
	spl.each(function(pv){
		var pair = pv.split("="),
			key = decodeURIComponent(pair.shift()),
			value = decodeURIComponent(pair.length > 1? pair.join("=") : pair[0])
		
		params[key] = value;	
	});
	return params;
};


String.prototype.ucfirst = function() {
	if (this.length == 0) {
		return "";
	}
	//console.log(this, this.substr(0,1));
	return this.substr(0,1).toUpperCase() + this.substr(1);
};

String.prototype.has = function(substring) {
    return this.indexOf(substring)>-1;
};

String.prototype.htmlSpecialChars = function() {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(this));
    return div.innerHTML;
};

String.prototype["in"] = function (variants) {
    if (!Object.isArray(variants)) {
        variants = Array.prototype.slice.call(arguments, 0);
    }
    return variants.contains(this.toString());
};


/**
 * "{} and {}".format(1,2) => 1 and 2
 * "{1} and {2}".format(1,2) = > 1 and 2 
 * "{1} and {2} [and {3}]".format(1,2) => 1 and 2 
 * "{1} and {2} [and {3}]".format(1,2,3) => 1 and 2 and 3
 * "{1} and \[string\]".format(1) => 1 and [string]
 *
 */
String.prototype.format = function () {

	var parameters = Array.prototype.slice.apply(arguments, [0]);

	function replaceNamedParameters(string) {

		var everyIsEmpty = true;

		var str = string.replace(/\{(\d+)\}/g, function (m0, m1) {
			m1 = ((m1 | 0) - 1)
			if (parameters[m1] !== undefined && parameters[m1] !== "" && parameters[m1] !== null) {
				everyIsEmpty = false;
			}

			return parameters[m1] === undefined ? "" : parameters[m1];
		});

		return {
			str: str,
			empty: everyIsEmpty
		}
	}
	;

	var idx = 1;
	var stmt = this.replace(/\{\}/g, function () {
		return "{" + (idx++) + "}";
	});

	//stmt = stmt.replace('\\[', "\4").replace('\\]', "\5");
	stmt = stmt.replace('\\[', "\x04").replace('\\]', "\x05");

	stmt = stmt.replace(/\[([^\]]+)\]/g, function (m, m1) {

		var replacement = replaceNamedParameters(m1);

		if (replacement.empty) {
			return "";
		}
		return replacement.str;
	});

	//stmt = stmt.replace("\4", "[").replace("\5", "]");
	stmt = stmt.replace("\x04", "[").replace("\x05", "]");

	var replacement = replaceNamedParameters(stmt);
	return replacement.str;
};

/**
 * Functions prototype
 */


Object.extend(Function.prototype,(function(){
    
    var extend = function(cls){
        var parentCls = cls;
        this.prototype.parent = null;

        var self = this;

        var tconstruct = this.prototype.constructor.toString();
        if (!tconstruct.match(/this\.inherit\.apply/)) {
            throw "You should call inherit method like: this.inherit.apply(this,arguments) here";
        }

       /* this.constructor = function() {
            tconstruct.apply(this.arguments);
        };*/

        this.prototype.inherit = function(){
            if (Object.isFunction(this.construct)) {
                this.construct.apply(this,arguments);
            }
            if(null === this.parent){
                this.parentCreate.apply(this,arguments);
            }
        };

        this.prototype.parentCreate = function(){
            this.parent = new parentCls(arguments);
            for(var prop in this.parent){
                if(this[prop] === undefined){
                    this[prop] = this.parent[prop];
                }
            }
            if (Object.isFunction(this.parent.construct)) {
                this.parent.construct.apply(this, arguments);
            }
        };
        return this;
    };
    
    var mix = function() {
        var mixins = Array.prototype.slice.call(arguments, 0);
        
        for (var i = 0; i < arguments.length; i++) {

            var mixin = (typeof arguments[i] == "function") ? new arguments[i]() : arguments[i];

            for (var prop in mixin) {

                var mixinedProperty =  mixin[prop];

                if (ko.isObservable(mixinedProperty) && !ko.isComputed(mixinedProperty) && typeof arguments[i] != "function") {
                    var mixinValue = ko.unwrap(mixinedProperty);
                    mixinedProperty = ko.observable(mixinValue);
                } 
                
                this.prototype[prop] = mixinedProperty;
             }
        }

    };
    return {
        extend: extend,
        mix: mix
    };
})());



/**
 * Number prototypes
 */
Number.prototype.minutesToTime = function() {
	return String(Math.floor(this/60)).pad(2) + ":" + String(this%60).pad(2);
};
/*
 * 
 * @deprecated Старая и неправильно работает
 * @use Number.prototype.secondsToTime
 */
Number.prototype.toTime = function() {
	var format = "";
	if (arguments[0]) {
		format = arguments[0];
	} else {
		format = "i:s";
		if (this > 3600) {
			format = "H:i:s";
		}
	}
        
        if (this > 84600) {
            format = "j д. H:i:s";
        }
        
	return (new Date(this * 1000)).timeOffset(format);
};

/**
 * Преобразует число в секундах в строку врмени
 * 90060 -> "[j дн. ] H:i:s" -> 1 дн. 01:01:05
 * @param {String} format   -   формат строки
 * @returns {String}
 */
Number.prototype.secondsToTime = function (format) {

    var order = [
        [{l: "d", m: 86400, p: true}, {l: "j", m: 86400, p: false}],
        [{l: "H", m: 3600, p: true}, {l: "G", m: 3600, p: false}],
        [{l: "i", m: 60, p: true}, {l: "k", m: 60, p: false}],
        [{l: "s", m: 1, p: true}, {l: "X", m: 1, p: false}]
    ],
        seconds = this;


    var replacer = function (string, partial) {

        var counter = 0;

        order.each(function (variants) {
            variants.some(function (rule) {

                var letter = rule.l,
                        multiplier = rule.m || 1,
                        pad = rule.p || false;

                var foundedIndex = string.indexOf(letter);

                if (string.indexOf(letter) > -1 && (foundedIndex==0 || string[foundedIndex-1]!=="\\")) {
                    var currentResult = Math.floor(seconds / multiplier);
                    counter += currentResult;
                    seconds -= (currentResult * multiplier);
                    if (pad) {
                        currentResult = String(currentResult).pad(2);
                    }
                    string = string.replace(letter, currentResult);
                    return true;
                }
                return false;
            });
        });
        return partial && counter == 0 ? "" : string;
    };

    var escapedCollector = [],
            escapedIterator = 0;

    format = format.replace(/\\([^\\])/, function (all, letter) {

        var out = "{" + escapedIterator + "}"

        escapedIterator++;
        escapedCollector.push(letter);

        return out;
    });

    format = format.replace(/\[([^\]]+)\]/g, function (full, rpl) {
        return replacer(rpl, true);
    });

    format = replacer(format, false);

    format = format.replace(/\{(\d)\}/, function (all, idx) {
        return escapedCollector[idx] != undefined ? escapedCollector[idx] : "";
    });

    return format;
};

Number.prototype.toBytes = function (/*prefixex*/) {
    var prefix = 0,
            prefixes = arguments[0] || ["байт", "КБ", "МБ", "ГБ", "ТБ"],
            size = this;

    while (size > 1024) {
        size = size / 1024;
        prefix++;
    }
    size = Number(size).format(2, ",", " ");
    return size + " " + prefixes[prefix];
};

Number.prototype.toSpeed = function (/*prefixex*/) {
    var prefix = 0,
            prefixes = arguments[0] || ["бит/с", "кбит/с", "мбит/с", "гбит/с", "тбит/с"],
            size = this;

    while (size > 1024) {
        size = size / 1024;
        prefix++;
    }
    size = Number(size).format(2, ",", " ");
    return size + " " + prefixes[prefix];
};

/**
 * 
 * @param {type} decimals
 * @param {type} dec_point
 * @param {type} thousands_sep
 * @author  original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
 *          improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
 *           bugfix by: Michael White (http://crestidg.com)
 * @returns {String}
 */
Number.prototype.format = function(decimals, dec_point, thousands_sep) {
    var i, j, kw, kd, km,
        number = this;

    // input sanitation & defaults
    if (isNaN(decimals = Math.abs(decimals))) {
        decimals = 2;
    }
    if (dec_point == undefined) {
        dec_point = ",";
    }
    if (thousands_sep == undefined) {
        thousands_sep = ".";
    }

    i = parseInt(number = (+number || 0).toFixed(decimals)) + "";

    if ((j = i.length) > 3) {
        j = j % 3;
    } else {
        j = 0;
    }

    km = (j ? i.substr(0, j) + thousands_sep : "");
    kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
    //kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).slice(2) : "");
    kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");
    return km + kw + kd;
}

/**
 * Склоняет слово в зависимости от числительного
 * 
 * @usage Number(1).decword('файл','файла','файлов'); //1 файл
 *        Number(54).decword(54,'файл','файла','файлов'); //54 файла
 * 
 */
Number.prototype.decword = function() {
    var titles = [].slice.call(arguments, 0);
    if (titles.length < 2) {
        return "";
    }

    if (titles.length < 3) {
        titles[2] = titles[1];
    }

    var cases = [2, 0, 1, 1, 1, 2];
    return titles[(this % 100 > 4 && this % 100 < 20) ? 2 : cases[(this
            % 10 < 5) ? this % 10 : 5]];
};

Date.currentLanguage = "ru";

Date.monthes = {ru:["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"]};
Date.monthesCase = {ru:["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"]};

if (Date.dayOfWeek == undefined) {
    Date.dayOfWeek = {};
}


Date.dayOfWeek["ru"] = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
Date.dayOfWeekFull = {ru: ['Воскресение', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота']};
/**
 * Date prototypes
 */
Object.extend(Date.prototype,{
	timeOffset: function(format) {
            var tz = this.getTimezoneOffset() * 60000,
                dd = new Date(this.getTime() + tz);
                return dd.format(format);
	},
        
        
        getUTCDayBegin: function() {
            var data= new Date(this.getTime() - this.getTimezoneOffset()*60*1000);
            data.setUTCHours(0,0,0,0);
            return data;
        },
        getUTCDayEnd: function() {
            var data= new Date(this.getTime() - this.getTimezoneOffset()*60*1000);
            data.setUTCHours(23,59,59,0);
            return data;
        },
        
        dayEnd: function(utc) {
            var dt = new Date(this);  
            dt["set" + (utc? "UTC" : "") + "Hours"](23,59,59,999);
            return dt;
        },
        
        dayBegin: function(utc) {
            var dt = new Date(this);  
            dt["set" + (utc? "UTC" : "") + "Hours"](0,0,0,0);
            return dt;
        },

    getStandartDay: function() {
	    var day = this.getDay();
	    return day == 0? 6 : day-1;
    },
        
        normalize: function(){
            var d = this.getDate(),
                m = this.getMonth(),
                y = this.getFullYear();
            
            this.setUTCHours(0);
            this.setUTCMinutes(0);
            this.setUTCSeconds(0);
            this.setUTCMilliseconds(0);
            this.setUTCDate(d);
            this.setUTCMonth(m);
            this.setUTCFullYear(y);
            return this;
        },
        
        compare: function(date) {
            var daysNow = Math.floor(this.getTime()/86400000),
                dayComparing = Math.floor(date.getTime()/86400000);
            return daysNow === dayComparing;
        },
	
	format: function(format) { 

		var jsdate = this,
			_pad = function (n, c) {
                            n = String(n);
                            while (n.length < c) {
                                n = '0' + n;
                            }
                            return n;
		  	},
			formatChr = /\\?(.?)/gi,
			formatChrCb = function (t, s) {
                            return f[t] ? f[t]() : s;
	 		},
                        utc = false,
                        lang = Date.currentLanguage || "ru";
                        
                        if (typeof arguments[1] == "boolean") {
                            utc = arguments[1];
                            lang = arguments[2] || Date.currentLanguage/*"ru"*/;
                        }
                        if (typeof arguments[1] == "string") {
                            lang = arguments[1] || Date.currentLanguage/*"ru"*/;
                        }
	 		
			var f = {
				//DAY
                            d: function () { // Day of month w/leading 0; 01..31
			      return _pad(f.j(), 2);
			    },
			    j: function () { // Day of month wo/leading 0; 1..31
			      return utc? jsdate.getUTCDate(): jsdate.getDate();
			    },
			    l: function() { //Day of week full text; понедельник-воскресениес
                                var days = Date.dayOfWeekFull[lang]||Date.dayOfWeekFull["ru"];
			    	return utc? days[jsdate.getUTCDay()] : days[jsdate.getDay()];
			    },
			    D: function() { //Day of week text; пн-вс
                                var days = Date.dayOfWeek[lang]||Date.dayOfWeek["ru"];
			    	return utc? days[jsdate.getUTCDay()] : days[jsdate.getDay()];
			    },
                            z: function () {
                                var time = jsdate.getTime();
                                return Math.floor(time/86400000);
                            },
			    
			    //MONTH
			     m: function () { // Month w/leading 0; 01...12
			      return _pad(f.n(), 2);
			    },
				n: function () { // Month; 1...12
			      return (utc? jsdate.getUTCMonth() : jsdate.getMonth()) + 1;
			    },
			    
				t: function () { // Days in month; 28...31
				  var month = f.n(), //month index
				  	  lastDay = new Date(f.Y(), month, 0);
			      return lastDay.getDate();
			    },
			    
			    F: function() {
                                var monthes = Date.monthes[lang]||Date.monthes["ru"];
			    	return monthes[f.n()-1];
			    },
			    
			    f: function() {
                    var monthes = Date.monthesCase[lang]||Date.monthesCase["ru"];
			    	return monthes[f.n()-1];
			    },
			    
			    //YEAR
			    L: function () { // Is leap year?; 0 or 1
			      var j = f.Y();
			      return j % 4 === 0 & j % 100 !== 0 | j % 400 === 0;
			    },
				Y: function () { // Full year; e.g. 1980...2010
			      return utc? jsdate.getUTCFullYear() : jsdate.getFullYear();
			    },
			    y: function () { // Last two digits of year; 00...99
			      return f.Y().toString().slice(-2);
			    },
			    
			    //HOURS
			    g: function () { // 12-Hours; 1..12
			      return f.G() % 12 || 12;
			    },
			    G: function () { // 24-Hours; 0..23
			      return utc? jsdate.getUTCHours() : jsdate.getHours();
			    },
			    h: function () { // 12-Hours w/leading 0; 01..12
			      return _pad(f.g(), 2);
			    },
			    H: function () { // 24-Hours w/leading 0; 00..23
			      return _pad(f.G(), 2);
			    },
                k: function () { // Minutes wo/leading 0; 00..59
                    return utc? jsdate.getUTCMinutes() : jsdate.getMinutes();
                },
			    i: function () { // Minutes w/leading 0; 00..59
			      return _pad(utc? jsdate.getUTCMinutes() : jsdate.getMinutes(), 2);
			    },
			    s: function () { // Seconds w/leading 0; 00..59
			      return _pad(utc? jsdate.getUTCSeconds() : jsdate.getSeconds(), 2);
			    }
			};
			
		return format.replace(formatChr, formatChrCb);
	}
});

Math.log10 = Math.log10 || function(x) {
    return Math.log(x) / Math.LN10;
};


//////////////////
// WEBPACK FOOTER
// ../main/cdn/prototype/prototype.js
// module id = 4
// module chunks = 0